import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  sectionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
    paddingBottom: "8px",
    borderBottom: "1px solid #e0e0e0",
  },
  sectionTitle: {
    fontSize: "18px",
    fontWeight: 600,
    margin: 0,
  },
  editButton: {
    padding: "4px 8px",
    textTransform: "none",
    color: "#ec6535",
    "&:hover": {
      backgroundColor: "rgba(236, 101, 53, 0.08)",
    },
  },
}));

